import React, { createContext, PropsWithChildren, useContext } from "react";
import { generateClassName } from "../../../hooks/useAttributes";
import "./Tabs.css";


interface TabListContext {
  onClick: (value: any) => void;
  active: any;
  size?: "small" | "medium"
}

const CTX = createContext<TabListContext | null>(null);

const useTabs = () => {
  const context = useContext(CTX);
  if (!context) {
    throw new Error("useTabs must be used within a Tabs component");
  }
  return context;
};

export default function Tabs(props: PropsWithChildren<TabListContext>) {

  const {
    size = "medium"
  } = props;

  return (
    <CTX.Provider value={props}>
      <div className={`d-flex flex-row tabs tabs-${size}`} style={{ overflowX: "auto" }}>
        {props.children}
      </div>
    </CTX.Provider>
  )
}

export type TabProps = PropsWithChildren<{
  value: any;
}>

export function Tab(props: TabProps) {

  const {
    active,
    onClick,
    size = "medium"
  } = useTabs();

  const {
    value,
    children,
  } = props;

  const isActive = active === value;

  return (
    <div
      className={generateClassName(`transition font-s tab d-flex flex-row align-items-center justify-content-center gap-1 tab-${size}`, {
        value: isActive,
        onTrue: "tab-active"
      })}
      onClick={() => onClick(value)}
    >
      {
        children
      }
    </ div>
  )
}